import { Route, RouteProps } from 'react-router-dom'

export function PublicRoute({ component: Component, ...rest }: RouteProps) {
  return <Route {...rest} render={props => <Component {...props} />} />
}
